<template>
<div class="delivery-term">
  <DeliveryTermGeneric
    v-if="companyTerms === 'generic'"
    :customer="customer"
    :stock="stock"
    :ticket="ticket"
    :config="config"
    :dateTimeDelivery="dateTimeDelivery"
    :manufacturer="manufacturer"
  />
  <DeliveryTermEnelCe
    v-else-if="`${state}` === 'CE' && companyTerms === 'enel'"
    :customer="customer"
    :stock="stock"
    :ticket="ticket"
    :config="config"
    :dateTimeDelivery="dateTimeDelivery"
    :manufacturer="manufacturer"
  />
  <DeliveryTermEnelGo
    v-else-if="`${state}` === 'GO' && companyTerms === 'enel'"
    :customer="customer"
    :stock="stock"
    :ticket="ticket"
    :config="config"
    :dateTimeDelivery="dateTimeDelivery"
    :manufacturer="manufacturer"
  />
  <DeliveryTermCemar
    v-else-if="`${state}` === 'MA' && companyTerms === 'cemar'"
    :customer="customer"
    :stock="stock"
    :ticket="ticket"
    :config="config"
    :dateTimeDelivery="dateTimeDelivery"
    :manufacturer="manufacturer"
  />

  <DeliveryTermIascMa
    v-else-if="`${state}` === 'MA' && companyTerms === 'iasc'"
    :customer="customer"
    :stock="stock"
    :ticket="ticket"
    :config="config"
    :dateTimeDelivery="dateTimeDelivery"
    :manufacturer="manufacturer"
  />

  <DeliveryTermIascPi
    v-else-if="`${state}` === 'PI' && companyTerms === 'iasc'"
    :customer="customer"
    :stock="stock"
    :ticket="ticket"
    :config="config"
    :dateTimeDelivery="dateTimeDelivery"
    :manufacturer="manufacturer"
  />

  <DeliveryTermEquatorialPi
    v-else-if="`${state}` === 'PI' && companyTerms === 'equatorial'"
    :customer="customer"
    :stock="stock"
    :ticket="ticket"
    :config="config"
    :dateTimeDelivery="dateTimeDelivery"
    :manufacturer="manufacturer"
  />

  <delivery-term-energisa-pb
    v-else-if="`${state}` === 'PB' && companyTerms === 'energisa-paraiba'"
    :customer="customer"
    :stock="stock"
    :ticket="ticket"
    :config="config"
    :dateTimeDelivery="dateTimeDelivery"
    :manufacturer="manufacturer"
  />

  <DeliveryTermEnergisaBorboremaPb
    v-else-if="`${state}` === 'PB' && companyTerms === 'energisa-borborema'"
    :customer="customer"
    :stock="stock"
    :ticket="ticket"
    :config="config"
    :dateTimeDelivery="dateTimeDelivery"
    :manufacturer="manufacturer"
  />

  <DeliveryTermCelpa
    v-else-if="`${state}` === 'PA' && companyTerms === 'celpa'"
    :customer="customer"
    :stock="stock"
    :ticket="ticket"
    :config="config"
    :dateTimeDelivery="dateTimeDelivery"
    :manufacturer="manufacturer"
  />

  <DeliveryTermCelpaJurunas
    v-else-if="`${state}` === 'PA' && companyTerms === 'celpa-jurunas'"
    :customer="customer"
    :stock="stock"
    :ticket="ticket"
    :config="config"
    :dateTimeDelivery="dateTimeDelivery"
    :manufacturer="manufacturer"
  />

  <DeliveryTermIascAl
    v-else="`${state}` === 'AL' && companyTerms === 'iasc'"
    :customer="customer"
    :stock="stock"
    :ticket="ticket"
    :config="config"
    :dateTimeDelivery="dateTimeDelivery"
    :manufacturer="manufacturer"
  />
</div>
</template>

<script>
import DeliveryTermEnelCe from './EnelCe/DeliveryTermEnelCe'
import DeliveryTermEnelGo from './EnelGo/DeliveryTermEnelGo'
import DeliveryTermCemar from './Cemar/DeliveryTermCemar'
import DeliveryTermIascPi from './IascPi/DeliveryTermIasc'
import DeliveryTermIascAl from './IascAl/DeliveryTermIasc'
import DeliveryTermIascMa from './IascMa/DeliveryTermIasc'
import DeliveryTermEnergisaPb from './EnergisaPb/DeliveryTermEnergisaPb'
import DeliveryTermEnergisaBorboremaPb from './EnergisaBorboremaPb/DeliveryTermEnergisaBorboremaPb'
import DeliveryTermCelpa from './Celpa/DeliveryTermCelpa'
import DeliveryTermEquatorialPi from './EquatorialPi/DeliveryTermEquatorialPi'
import DeliveryTermCelpaJurunas from './CelpaJurunas/DeliveryTermCelpaJurunas'
import DeliveryTermGeneric from '../../../components/Trg/Terms/DeliveryTermGeneric'

export default {
  name: 'delivery-term',
  components: {
    DeliveryTermGeneric,
    DeliveryTermCelpaJurunas,
    DeliveryTermEquatorialPi,
    DeliveryTermEnelCe,
    DeliveryTermCemar,
    DeliveryTermEnelGo,
    DeliveryTermIascPi,
    DeliveryTermIascAl,
    DeliveryTermIascMa,
    DeliveryTermEnergisaPb,
    DeliveryTermEnergisaBorboremaPb,
    DeliveryTermCelpa
  },
  props: {
    ticket: {required: true},
    manufacturer: {required: true},
    config: {required: true},
    stock: {required: true},
    customer: {required: true},
    companyTerms: {required: true},
    dateTimeDelivery: {required: true}
  },

  computed: {
    state: function () {
      return this.config.state || false
    }
  }
}
</script>

<style scoped>
  .logo-term {
    max-height: 150px;
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/Terms/DeliveryTerm.vue